module.exports = __webpack_public_path__ + "static/img/xiazaijietu.156fdb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/xiazaijietu.png
// module id = uKjD
// module chunks = 24